import { useState } from 'react';
import { Form, Button, PageHeader } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import { commonVerticalLayout } from '../../../constants/formLayout';
import { apiService, notificationService, userService } from '../../../services';
import { Spinner } from '../../../components/Spinner';
import { dictionaries } from '../../../dictionaries';
import { CarTabs } from '../../../components/Tabs/CarTabs';
import { useFetchData } from '../../../hooks/useFetchData';
import { Permissions } from '../../../enums/permissions';
import { ACL } from '../../../components/ACL';
import { DeleteButton, Pages } from '1_shared';


export const BrandEditPage = () => {
  const navigate = useNavigate();
  const param: any = useParams();
  const [form] = Form.useForm();

  const { isLoading: isDataLoading, data = {} } = useFetchData(`/car-brands/${param.id}`);

  const [isSaveBtnDisabled, setSaveBtnDisabled]: any = useState(false);

  const hasAccess = userService.hasAccess([Permissions.SUPER_ADMIN, Permissions.ADMIN]);

  const isNew = !param.id;

  const subTitle = isNew ? 'Создание марки автомобиля' : 'Редактирование марки автомобиля';

  if (!isNew && isDataLoading) {
    return <Spinner />;
  }

  const handleCancel = () => {
    navigate(Pages.CARS);
  };

  const handleSave = async () => {
    try {
      setSaveBtnDisabled(true);

      await form.validateFields();
      const body = form.getFieldsValue();

      if (isNew) {
        const requestedData = await apiService.POST('/car-brands', body);

        navigate(`${Pages.BRANDS}/${requestedData.id}`);
      } else {
        await apiService.PATCH(`/car-brands/${data.id}`, body);
      }
      notificationService.notifySuccess('Марка автомобиля успешно сохранена');
      dictionaries.carDictionary.fetch();
    } catch (error) {
      notificationService.notifyError(error);
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  const deleteBrand = async () => {
    try {
      await apiService.DELETE(`/car-brands/${data.id}`);
      navigate(Pages.CARS);
      notificationService.notifySuccess('Марка успешно удалена');
      dictionaries.carDictionary.fetch();
    } catch (error) {
      notificationService.notifyError(error);
    }
  };

  return (
    <ACL roles={[Permissions.SUPER_ADMIN, Permissions.ADMIN]}>
      <>
        <PageHeader
          className="page-header"
          title="Марка"
          subTitle={subTitle}
          extra={[
            <DeleteButton
              key='delete-btn'
              confirmTitle='Вы действительно хотите удалить марку'
              onDelete={deleteBrand}
              disabled={isNew || !hasAccess}
            />,
            <Button key="2" onClick={handleCancel}>
              {isNew ? 'Отмена' : 'Закрыть'}
            </Button>,
            <Button
              key="1"
              type="primary"
              disabled={isSaveBtnDisabled || !hasAccess}
              onClick={handleSave}
            >
              Сохранить
            </Button>,
          ]}
        />
        <div className='page-content'>
          <Form
            className="mg-t-16"
            form={form}
            labelAlign="left"
            requiredMark={false}
            initialValues={data}
            layout="vertical"
            {...commonVerticalLayout}
          >
            <CarTabs generalTabProps={{ data, form }} />
          </Form>
        </div>
      </>
    </ACL>
  );
};
